@if (passwordToCheck) {
  <div class="align-center mt-0">
    <ul id="strengthBar">
      @for (barColor of barColors; track barColor) {
        <li class="point" [style.background-color]="barColor"></li>
      }
    </ul>
  </div>
}
